export const SmsIcon = () => {
  return (
    <svg fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.505 3H6.495C3.735 3 1.5 5.325 1.5 8.175V25.92C1.5 26.49 2.145 26.805 2.58 26.445L5.505 24.06C5.82 24.045 6.15 24.03 6.48 24.03H23.505C26.265 24.03 28.5 21.72 28.5 18.87V8.175C28.5 5.31 26.265 3 23.505 3ZM14.94 17.7H7.605C7.245 17.7 6.96 17.415 6.96 17.055C6.96 16.695 7.245 16.41 7.605 16.41H14.94C15.3 16.41 15.585 16.695 15.585 17.055C15.585 17.415 15.3 17.7 14.94 17.7ZM22.86 14.4H7.605C7.245 14.4 6.96 14.115 6.96 13.755C6.96 13.395 7.245 13.11 7.605 13.11H22.86C23.22 13.11 23.505 13.395 23.505 13.755C23.505 14.115 23.22 14.4 22.86 14.4ZM22.86 11.1H7.605C7.245 11.1 6.96 10.815 6.96 10.455C6.96 10.095 7.245 9.81 7.605 9.81H22.86C23.22 9.81 23.505 10.095 23.505 10.455C23.505 10.815 23.22 11.1 22.86 11.1Z"
        fill="#004DBC"
      />
    </svg>
  );
};
